import { gql } from '../../../apollo/__generated__';

export const STAFF_CREATE_TRANSACTION = gql(`
  mutation StaffCreateTransaction($createTransactionInput: StaffCreateTransactionInput!, $eventId: ID!) {
    staffCreateTransaction(createTransactionInput: $createTransactionInput) {
      id
      user {
        id
        hasPaidTicket(eventId: $eventId)
      }
    }
  }
`);
